var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke-width:25;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M571.1,193.9c23.5,23.5,9.4,47.5-14.1,71l-32.8,32.8c-102.7,102.7,171,376.5,273.8,273.8l103.9-103.9 c147.8-147.8-195.5-491.1-343.3-343.3l-151,151c-1.2,1.2-2.4,2.4-3.5,3.6c-48.7,50.1-80.2,114.3-91.4,183.2l-7.7,47.5l227.9,227.9 l30.6,1.4c94.3,4.4,186.2-31.1,253-97.9l0,0c31.5-31.5,43.8-69,10-98.1l0,0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.7,917.9L104,672.2c-23.9-23.9-23.9-62.6,0-86.5l95.3-95.3c23.9-23.9,62.6-23.9,86.5,0l245.7,245.7 c23.9,23.9,23.9,62.6,0,86.5l-95.3,95.3C412.3,941.8,373.5,941.8,349.7,917.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387.3,689.5l52.4,52.4c16.8,16.8,16.8,44,0,60.8L337.1,905.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxing);
export default __webpack_public_path__ + "static/media/Boxing.03accac5.svg";
export { ForwardRef as ReactComponent };